import { render, staticRenderFns } from "./CardButton.vue?vue&type=template&id=64c3e152&lang=pug&"
import script from "./CardButton.vue?vue&type=script&lang=ts&"
export * from "./CardButton.vue?vue&type=script&lang=ts&"
import style0 from "./CardButton.vue?vue&type=style&index=0&id=64c3e152&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports